import { ref } from 'vue'

import AuthWelcome from '@/components/auth/parts/steps/AuthWelcome.vue'
import AuthInitialRegister from '@/components/auth/parts/steps/AuthInitialRegister.vue'
import AuthProfileRegister from '@/components/auth/parts/steps/AuthProfileRegister.vue'
import AuthArtistRegisterFirstStep from '@/components/auth/parts/steps/AuthArtistRegisterFirstStep.vue'
import AuthArtistRegisterSecondStep from '@/components/auth/parts/steps/AuthArtistRegisterSecondStep.vue'
import AuthVenueRegisterFirstStep from '@/components/auth/parts/steps/AuthVenueRegisterFirstStep.vue'
import AuthVenueRegisterSecondStep from '@/components/auth/parts/steps/AuthVenueRegisterSecondStep.vue'
import AuthVenueRegisterThirdStep from '@/components/auth/parts/steps/AuthVenueRegisterThirdStep.vue'
import AuthFinalizeStep from '@/components/auth/parts/steps/AuthFinalizeStep.vue'

const profileRegisterSteps = ref([
    {
        identifier: 'general-welcome',
        titles: ['Log in or Create Account'],
        component: AuthWelcome
    },
    {
        identifier: 'initial-register',
        titles: ['Create Account'],
        component: AuthInitialRegister
    },
    {
        identifier: 'profile-register',
        titles: ['Account Created'],
        component: AuthProfileRegister
    },
    {
        identifier: 'artist-register-one',
        titles: ['Create Artist Profile', 'Step 1/2'],
        component: AuthArtistRegisterFirstStep
    },
    {
        identifier: 'artist-register-two',
        titles: ['Create Artist Profile', 'Step 2/2'],
        component: AuthArtistRegisterSecondStep
    },
    {
        identifier: 'artist-finalize-reg',
        titles: ['Create Artist Profile'],
        component: AuthFinalizeStep,
        props: {
            mode: 'artist'
        }
    },
    {
        identifier: 'venue-register-one',
        titles: ['Create Booking Profile', 'Step 1/3'],
        component: AuthVenueRegisterFirstStep
    },
    {
        identifier: 'venue-register-two',
        titles: ['Create Booking Profile', 'Step 2/3'],
        component: AuthVenueRegisterSecondStep
    },
    {
        identifier: 'venue-register-three',
        titles: ['Create Booking Profile', 'Step 3/3'],
        component: AuthVenueRegisterThirdStep
    },
    {
        identifier: 'venue-finalize-reg',
        titles: ['Create Booking Profile'],
        component: AuthFinalizeStep,
        props: {
            mode: 'venue'
        }
    }
])
export const useProfileSteps = () => {
    return {
        profileRegisterSteps
    }
}
